export default __webpack_public_path__ + "static/media/erythree_carte_2-min.a2c4201a.png";